import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import Input from '../../input'
import ButtonContained from '../../button';
import { AddAgentSchema } from '../../../validation/ValidationSchema';
import { getBrands,getRegionList } from '../../../helpers/listsApi';
import { api } from '../../../api';
import { toast } from "react-toastify";
import { useNavigate} from 'react-router-dom';
import { useSelector } from "react-redux";
import usePasswordToggle from '../../hooks/usePasswordToggle';
import DropdownComp from '../../dropdown';

const AddAgent = () => {
    const token = useSelector((state) => state.auth.token);
    // eslint-disable-next-line
    const { userType: role } = useSelector((state) => state.auth.user);
    const [PwdInputType, ToggleIcon] = usePasswordToggle();
    const navigate = useNavigate();
    // eslint-disable-next-line
    const status = [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" }
    ]
   

    const [agentRegionOptions, setAgentRegionOptions] = useState([]);
       useEffect(() => {
        const fetchData = async () => {
            try {
            const regionList = await getRegionList(null, token);

            if (regionList) {
                setAgentRegionOptions(regionList);
            } else {

                setAgentRegionOptions([]);
            }
            } catch (error) {
            setAgentRegionOptions([]);
            }
        };

        fetchData();
        }, [token]);





    
    // eslint-disable-next-line
    const [brands, setBrands] = useState([])


    useEffect(() => {
        getBrands({},token).then(res => {
            setBrands(res);
        })
    }, [token])
    return (

        <Formik
            validationSchema={AddAgentSchema}
            initialValues={{
                usersUserName: '',
                usersUserType: '2',
                usersPhone: '',
                usersEmail: '',
                usersName: '',
                usersBrand: '',
                usersPassword: '',
                confpassword: '',
                agentRegions:[],
                is2faEnabled: true
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {

                const formBody = {
                usersUserName: values.usersUserName,
                usersUserType: '2',
                usersName: values.usersName,
                usersPhone: values.usersPhone,
                usersEmail: values.usersEmail,
                usersBrand: values.usersBrand,
                usersPassword: values.usersPassword,
                confpassword: values.confpassword,
                resellerRegionId: values.agentRegions.map(region => region.value),
                is2faEnabled: values.is2faEnabled,
                };
            
                api.users.create(formBody,token).then(result => {
                    if (result.success === false) {
                        toast.error(result.message);
                        resetForm({});
                    } else {
                        toast.success(result.message);
                        navigate('/admin-agent')
                    }
                    setSubmitting(false)

                }).catch(err => {
                    console.log(err)
                });
            }}
        >
            {({
                handleSubmit,
                handleChange,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue
            }) => {

                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">ADD AGENT</h1>
                                    </div>
                                    <div className="card card-table">
                                        {/* <div className="card-header card-header-title">Agent Details</div> */}
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports agents">
                                                <Form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersUserName"
                                                                name="usersUserName"
                                                                placeholder="User Name"
                                                                type="text"
                                                                label="User Name"
                                                                value={values.usersUserName}
                                                                onChange={handleChange}
                                                                error={touched.usersUserName && errors.usersUserName}
                                                                errorText={errors.usersUserName}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersPhone"
                                                                name="usersPhone"
                                                                placeholder="Phone Number"
                                                                type="number"
                                                                label="Phone"
                                                                value={values.usersPhone}
                                                                onChange={handleChange}
                                                                error={touched.usersPhone && errors.usersPhone}
                                                                errorText={errors.usersPhone}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersEmail"
                                                                name="usersEmail"
                                                                placeholder="Email Id"
                                                                label="Email"
                                                                value={values.usersEmail}
                                                                onChange={handleChange}
                                                                error={touched.usersEmail && errors.usersEmail}
                                                                errorText={errors.usersEmail}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>

                                                    <div className="form-row">

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersName"
                                                                name="usersName"
                                                                placeholder="Name"
                                                                label="Agent Name"
                                                                value={values.usersName}
                                                                onChange={handleChange}
                                                                error={touched.usersName && errors.usersName}
                                                                errorText={errors.usersName}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersPassword"
                                                                name="usersPassword"
                                                                type={PwdInputType}
                                                                placeholder="Password"
                                                                onPaste={true}
                                                                autoComplete="usersPassword"
                                                                label="Set Password"
                                                                value={values.usersPassword}
                                                                onChange={handleChange}
                                                                error={touched.usersPassword && errors.usersPassword}
                                                                errorText={errors.usersPassword}
                                                                disabled={isSubmitting} 
                                                                isToggle={ values.usersPassword ? true: false }
                                                                toggleIcon={ ToggleIcon }/>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="confpassword"
                                                                name="confpassword"
                                                                type="password"
                                                                placeholder="Confirm Password"
                                                                label="Confirm Password"
                                                                autoComplete="confpassword"
                                                                value={values.confpassword}
                                                                onChange={handleChange}
                                                                onPaste={true}
                                                                error={touched.confpassword && errors.confpassword}
                                                                errorText={errors.confpassword}
                                                                disabled={isSubmitting} />
                                                        </div>
                                               
                                                    
                                                            <div className="form-group col-md-4">
                                                                <DropdownComp
                                                                id="agentRegions"
                                                                name="agentRegions"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("agentRegions", selectedValue);
                                                                }}
                                                                value={values.agentRegions}
                                                                options={agentRegionOptions} // make sure this variable is defined
                                                                label="Regions"
                                                                placeholder="Please select Region"
                                                                isMulti
                                                                error={touched.agentRegions && errors.agentRegions}
                                                                errorText={errors.agentRegions}
                                                                disabled={isSubmitting}
                                                                />
                                                            </div>

                                                            <div className="form-group col-md-4">
                                                            <label htmlFor="is2faEnabled" className="d-block mb-2">
                                                                Enable 2FA
                                                            </label>
                                                            <div className="custom-control custom-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="is2faEnabled"
                                                                    name="is2faEnabled"
                                                                    checked={values.is2faEnabled}
                                                                    onChange={(e) => setFieldValue("is2faEnabled", e.target.checked)}
                                                                    disabled={isSubmitting}
                                                                />
                                                                <label className="custom-control-label" htmlFor="is2faEnabled">
                                                                    {values.is2faEnabled ? "Enabled" : "Disabled"}
                                                                </label>
                                                            </div>
                                                        </div>
                                                            

                                                            
                                                    </div>

                                                <ButtonContained buttonName="Save" type="submit"
                                                    disabled={isSubmitting} />
                                                </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
    )
}}
        </Formik >
    )
}

export default AddAgent;